import { EnumLocaleDescriptions } from '../enumLocale'
export default {
  [EnumLocaleDescriptions.des_officialAccount]: 'Official Account',
  [EnumLocaleDescriptions.des_sinaWeibo]: 'Sina Weibo',
  [EnumLocaleDescriptions.des_xt]: 'Xuan Tong',
  [EnumLocaleDescriptions.des_contactUs]: 'Contact Us',
  [EnumLocaleDescriptions.des_copyright]: 'Copyright Notice'
}
